import React from 'react';
import { NavLink } from 'react-router-dom';
import CardBlog from '../Card/CardBlog';

const Blog = (props) => {
  return (
    <section className='news_container'>
      <div className='container'>
        {/* Only render this section if the current path is not '/news' */}
        {props.currentPath !== '/news' && (
          <div className='text-center mb-5'>
            <h3 className='bold font__size--48 text__50-1024 text__50-sm text__50-xs'>
              {props.title}
            </h3>
          </div>
        )}
        <div className='row'>
          {props.blog?.map((obj) => (
            <div className='col-lg-4 mb-4' key={obj.id}>
              <CardBlog data={obj} />
            </div>
          ))}
        </div>

        {/* Only render this section if the current path is not '/news' */}
        {props.currentPath !== '/news' && (
          <div className='text-center mt-5'>
            <div className='d-inline-block'>
              <NavLink to='/news'>
                <div className='more__blog'>
                  <button className='semi-bold font__size--14 text__14-1024 btn btn__outlined--blue color__blue no__opacity rounded-2 shadow'>
                    ყველა სიახლის ნახვა
                  </button>
                </div>
              </NavLink>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Blog;
